<template>
	<Button :class="['two-tone-plan-selector', { active }]" :action="action">
		<div class="front side">
			<div class="text"><slot></slot></div>
		</div>
		<div class="back side">
			<div class="text"><slot></slot></div>
		</div>
	</Button>
</template>

<script>
import Button from '@/components/base/Button';

export default {
	name: 'FlipButton',
	components: {
		Button,
	},
	props: {
		active: {
			type: Boolean,
			default: false,
		},
		action: {
			type: Function,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.two-tone-plan-selector {
		cursor: pointer;
		position: relative;
		margin: 0 5px 20px;
		padding: 0;

		border: solid $border-width-md;
		border-image: linear-gradient(90deg, $alt-color-light, $alt-color-extra-light, $alt-color) 1;
		perspective: 800px;
		transform-style: preserve-3d;


		.side {
			padding: 1em 2.2em;
			background: linear-gradient(to bottom, #E26F39 50%, #993E26 50%);
			user-select: none;
			transition: all $ui-transition-duration;

			font-family: $heading-font;
			font-size: $font-size-lg;
			letter-spacing: $letter-spacing-plus;
			color: $alt-color-extra-light;
			text-transform: uppercase;
			text-align: center;
			line-height: 1;
			text-align: center;
			z-index: 1;
			backface-visibility: hidden;

			&:before {
				content: " ";
				position: absolute;
				z-index: 1;
				top: .25em;
				left: .25em;
				right: .25em;
				bottom: .25em;
				border: solid $border-width-sm;
				border-image: linear-gradient(90deg, $alt-color-light, $alt-color-extra-light, $alt-color) 1;
			}
		}

		.back {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			color: white;
			background: linear-gradient(to bottom, $primary-color-extra-light 50%, $primary-color-light 50%);
			transform: rotateX(180deg);
		}

		transform: rotateX(0deg);

		&.active {
			transition: all .5s;
			transform: rotateX(180deg);
		}
	}

</style>
